import * as React from 'react';

export const MorningDeliveryIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='55'
    height='32'
    viewBox='0 0 3338 4197'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g id='Picto_Morning_Delivery'>
      <g id='Picto_Monring_Delivery'>
        <path
          id='Item_Color'
          d='M1681.01 2424.52L1176.01 3582.52C803.514 3407.02 335.402 2929.52 452.513 2255.02C600.513 1402.62 1334.18 1196.85 1681.01 1199.02V2424.52Z'
          fill='url(#paint0_linear_3_3)'
        />
        <g id='Item_Black' fill='black'>
          <g id='Group'>
            <path
              id='Vector'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M3088.61 2240.28C3097.93 2306.1 3054.27 2347.98 3001.76 2347.98C2949.24 2347.98 2908.11 2321.98 2899.74 2263.9M2899.74 2263.9C2813.4 1665.27 2297.76 1204.65 1675.37 1204.65C992.608 1204.65 438.29 1758.97 438.29 2441.73C438.29 3124.5 992.606 3678.81 1675.37 3678.81C1932.55 3678.81 2171.51 3600.18 2369.47 3465.62C2412.9 3436.1 2457.16 3457.08 2486.68 3500.51C2516.2 3543.94 2519.87 3593.49 2476.44 3623.01C2247.97 3778.3 1972.19 3869.11 1675.37 3869.11C887.582 3869.11 248 3229.52 248 2441.74C248 1653.95 887.585 1014.37 1675.37 1014.37C2394.78 1014.37 2990.6 1547.75 3088.61 2240.29'
            />
            <path
              id='Vector_2'
              d='M1682.14 1522.86V2432.55'
              stroke='black'
              strokeWidth='108.33'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_3'
              d='M1678.87 2440.56L1446.99 3003.3'
              stroke='black'
              strokeWidth='108.33'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <circle id='Vector_4' cx='1682.78' cy='2418.19' r='118.98' />
          </g>
          <g id='Group_2'>
            <path
              id='Vector_5'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M1208.08 911.551C1211.8 915.801 1213.06 921.662 1211.44 927.066C1209.81 932.471 1205.52 936.658 1200.08 938.151C1123.39 960.891 879.807 1047.3 636.765 1284.07C525.195 1392.76 440.958 1521.01 410.16 1570.67C407.281 1575.48 402.183 1578.53 396.584 1578.78C390.985 1579.04 385.631 1576.47 382.324 1571.95C217.361 1344.41 258.983 1025.08 480.922 847.939C702.586 671.021 1022.68 700.949 1208.08 911.551Z'
            />
            <path
              id='Vector_6'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2115.24 910.534C2111.53 914.784 2110.26 920.645 2111.89 926.049C2113.52 931.454 2117.81 935.641 2123.25 937.135C2199.94 959.874 2443.52 1046.28 2686.56 1283.05C2798.13 1391.74 2882.37 1519.99 2913.17 1569.66C2916.04 1574.46 2921.14 1577.51 2926.74 1577.77C2932.34 1578.02 2937.69 1575.46 2941 1570.93C3105.96 1343.39 3064.34 1024.06 2842.4 846.922C2620.74 670.004 2300.64 699.932 2115.24 910.534Z'
            />
            <path
              id='Vector_7'
              fillRule='evenodd'
              clipRule='evenodd'
              d='M917.615 831.736C918.934 857.947 898.726 880.298 872.515 881.618C846.305 882.937 823.954 862.729 822.634 836.518C810.46 594.716 953.818 465.255 1139.54 397.713C1311.31 335.247 1520.3 328 1658.31 328C1796.14 328 2019.35 329.476 2204.05 397.623C2401.57 470.504 2557.44 615.832 2539.63 904.685C2538.01 930.879 2515.44 950.835 2489.24 949.22C2463.05 947.605 2443.09 925.027 2444.71 898.833C2459.19 663.898 2331.78 546.121 2171.13 486.845C1997.65 422.834 1787.78 423.101 1658.31 423.101C1529 423.101 1332.99 428.557 1172.05 487.087C1025.05 540.543 907.979 640.363 917.615 831.736Z'
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_3_3'
        x1='1641.01'
        y1='1198.52'
        x2='766.513'
        y2='3314.52'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0.380509'
          stopColor='var(--primary-color)'
          stopOpacity='0.2'
        />
        <stop offset='1' stopColor='var(--primary-color)' stopOpacity='0.8' />
      </linearGradient>
    </defs>
  </svg>
);
